// extracted by mini-css-extract-plugin
module.exports = {"payment":"Payment_payment__tLKsY","placeholder":"Payment_placeholder__80GyD"};